import { Injectable, ViewChildren, QueryList } from '@angular/core';
import {
  IonRouterOutlet,
  ActionSheetController,
  PopoverController,
  ModalController,
  MenuController,
} from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AutoCloseOverlaysService {

  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  lastTimeBackPress = 0;
  timePeriodToExit = 2000;

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private menu: MenuController
  ) {}

  async trigger() {
    return new Promise(async (resolve, reject) => {
      try {
        const element = await this.actionSheetCtrl.getTop();
        if (element && element != undefined) {
          element.dismiss();
          console.log('actionSheetCtrl');
          return resolve(true);
        }
      } catch (error) {}
  
      // close popover
      try {
        const element = await this.popoverCtrl.getTop();
        if (element && element != undefined) {
          element.dismiss();
          console.log('popoverCtrl');
          return resolve(true);
        }
      } catch (error) {}
  
      // close modal
      try {
        const element = await this.modalCtrl.getTop();
        if (element && element != undefined) {
          element.dismiss();
          console.log('modalCtrl');
          return resolve(true);
        }
      } catch (error) {
        console.log(error);
      }
  
      // close side menu
      try {
        const element = await this.menu.getOpen();
        if (element && element != undefined) {
          this.menu.close();
          console.log('menu');
          return resolve(true);
        }
      } catch (error) {}
      
      return resolve(false);
    });
  }
}
